var t = "_wrapper_1mk32_1",
    e = "_title_1mk32_7",
    n = "_multiline_1mk32_15",
    i = "_container_1mk32_25",
    _ = {
  wrapper: t,
  title: e,
  multiline: n,
  container: i
};
export { i as container, _ as default, n as multiline, e as title, t as wrapper };